<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.filter' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-date-field(
            :label="'reports.date_from' | translate"
            v-model="localFilters.planned_on_after")
        .cols-x__2
          v-date-field(
            :label="'reports.date_to' | translate"
            v-model="localFilters.planned_on_before")
      v-multiselect.mb-3(
        itemValue="key"
        :label="'reports.statuses' | translate"
        :options="statuses"
        v-model="localFilters.status")
      v-multiselect.mb-3(
        :label="$t('reports.rations')"
        itemValue="id"
        :options="rationsList"
        v-model="localFilters.animalfeed_recipe")
      .cols-x
        .cols-x__2
          v-input.m-none(
            :label="$t('base.download_time_from')"
            v-model="localFilters.loaded_time_min")
        .cols-x__2
          v-input.m-none(
            :label="$t('base.download_time_to')"
            v-model="localFilters.loaded_time_max")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onApply") {{ 'base.apply' | translate }}
      v-btn(
        text
        @click="onReset")
        | {{ 'base.clear' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDateForDatePicker } from '@/util'
export default {
  name: 'FiltersModal',

  mounted () {
    if (!this.filters.planned_on_before && !this.filters.planned_on_after) {
      const today = getDateForDatePicker(this.timezone)
      this.$store.dispatch('reports/applyFilters', {
        planned_on_before: today,
        planned_on_after: today,
      })
    }
    for (const key in this.filters) {
      this.localFilters[key] = this.filters[key]
      this.localFilters.planned_on_after = getDateForDatePicker(this.timezone)
      this.localFilters.planned_on_before = getDateForDatePicker(this.timezone)
    }
    this.loadRationsList({farm: this.$route.params.farm_id})
  },

  data: () => ({
    localFilters: {
      planned_on_after: null,
      planned_on_before: null,
      status: [],
      animalfeed_recipe: [],
      loaded_time_min: null,
      loaded_time_max: null
    },
    statuses: [
      { id: 0, name: 'status.waited', key: 'waited' },
      { id: 1, name: 'status.in_process', key: 'in_process' },
      { id: 2, name: 'status.uploaded', key: 'loaded' },
      { id: 3, name: 'status.loaded', key: 'uploaded' },
      { id: 4, name: 'status.out_process', key: 'out_process' },
    ],
    loading: false
  }),

  methods: {
    ...mapActions('rations', [
      'loadRationsList'
    ]),
    ...mapActions('reports', [
      'applyFilters',
      'resetFilters',
    ]),

    ...mapActions('kkzreports', [
      'loadReports'
    ]),

    async onApply () {
      this.loading = true
      this.localFilters.farm = this.$route.params.farm_id
      this.applyFilters(this.localFilters)
      // await this.loadReports(this.localFilters)
      this.loading = false
      this.$emit('close')
    },

    async onReset () {
      this.localFilters.planned_on_after = getDateForDatePicker(this.timezone)
      this.localFilters.planned_on_before = getDateForDatePicker(this.timezone)
      this.localFilters.status = []
      this.localFilters.animalfeed_recipe = []
      this.localFilters.loaded_time_min = null
      this.localFilters.loaded_time_max = null
      this.resetFilters()
      const allowedKeys = ['farm', 'planned_on_before', 'planned_on_after', 'page']
      const newQuery = {}

      for (const key of allowedKeys) {
        if (this.$route.query[key]) {
          newQuery[key] = this.$route.query[key]
        }
      }

      newQuery.page = 1

      this.$router.replace({ query: newQuery })
      this.$emit('close')
    }
  },

  computed: {
    ...mapGetters('kkzreports', [
      // 'filters'
    ]),
    ...mapGetters('reports', [
      'filters',
    ]),

    ...mapGetters('rations', [
      'rationsList'
    ]),
    timezone () {
      return this.$store.getters['account/timezone']
    },
  }
}
</script>
